import styled from '@emotion/styled'
import { colors, fontFamilies } from '@configs/styles/config'
import { useTranslation } from 'react-i18next'

const AboutContainer = styled.section`
  background: ${colors.uguPurple};
  color: white;
  padding: 6rem 1rem;
  margin: 0;
  position: relative;
`

const ContentWrapper = styled.div`
  max-width: 1500px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  /* align-items: center; */

  @media (min-width: 1024px) {
    grid-template-columns: 1.2fr 0.8fr;
    gap: 5rem;
  }
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

const MainTitle = styled.div`
  font-size: 2.85rem;
  font-family: ${fontFamilies.semiBold};
  color: white;
  line-height: 1.2;
  margin: 0;
  max-width: 680px;

  @media (min-width: 768px) {
    font-size: 3rem;
  }

  @media (min-width: 1024px) {
    font-size: 3.2rem;
  }
`

const MainDescription = styled.p`
  font-size: 24px;
  line-height: 1.7;
  color: #d1d1f7;
  font-family: ${fontFamilies.regular};
  margin: 0;
  max-width: 600px;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`

const FeatureBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const FeatureTitle = styled.div`
  font-size: 24px;
  font-family: ${fontFamilies.semiBold};
  color: white;
  margin: 0;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 1.65rem;
  }
`

const FeatureDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #d1d1f7;
  font-family: ${fontFamilies.regular};
  margin: 0;

  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
`

interface Section {
  title: string
  description: string
}

type Props = {
  customSections?: Section[]
  mainTitle?: string
  mainDescription?: string
}

const About = ({ customSections, mainTitle, mainDescription }: Props) => {
  const { t } = useTranslation('resources/onlineCourses')

  const sections = customSections || [
    {
      title: t('about.features.0.title'),
      description: t('about.features.0.description'),
    },
    {
      title: t('about.features.1.title'),
      description: t('about.features.1.description'),
    },
    {
      title: t('about.features.2.title'),
      description: t('about.features.2.description'),
    },
  ]

  return (
    <AboutContainer className="rounded-t-[26px]">
      <ContentWrapper>
        <LeftContent>
          <MainTitle>{mainTitle || t('about.mainTitle')}</MainTitle>
          <MainDescription>
            {mainDescription || t('about.mainDescription')}
          </MainDescription>
        </LeftContent>

        <RightContent>
          {sections.map((section, index) => (
            <FeatureBlock key={index}>
              <FeatureTitle>{section.title}</FeatureTitle>
              <FeatureDescription>{section.description}</FeatureDescription>
            </FeatureBlock>
          ))}
        </RightContent>
      </ContentWrapper>
    </AboutContainer>
  )
}

export default About
